module.exports = __webpack_public_path__ + "img/luckycoin.ce34ac6f.png";